// removed by extract-text-webpack-plugin
module.exports = {"root":"_19IX"};


//////////////////
// WEBPACK FOOTER
// ./~/@pickle/pickle-shared/src/components/Layout/Row/Row.css
// module id = NmWt
// module chunks = 0